// @ts-nocheck
import Link from 'next/link';

import { staticLinks } from '@/config/routingLinks';

import { THouseContent } from './types';

import styles from './HomeQRs.module.scss';
import qrCulture from 'assets/QRs/qr_culture.jpg';
import qrDogovor from 'assets/QRs/qr_gosuslugi-dogovor.png';
import qrKapital from 'assets/QRs/qr_gosuslugi-kapital.png';
import qrIpoteka from 'assets/QRs/qr_ipoteka-sakhalin.jpg';
import qrNalog from 'assets/QRs/qr_minstroy-nalog.jpg';
import qrStep from 'assets/QRs/qr_minstroy-step.jpg';
import qrUchastie1 from 'assets/QRs/qr_minstroy-uchastie1.jpg';
import qrUchastie2 from 'assets/QRs/qr_minstroy-uchastie2.jpg';
import qrProgrammy from 'assets/QRs/qr_msz-programms.png';
import qrSport from 'assets/QRs/qr_sport.jpg';

export const meta = {
  title: 'Дом - как решить жилищный вопрос',
};
export const houseAccordionContent = [
  {
    title: 'Как решить жилищный вопрос?',
    additional: (
      <div className={styles.additional}>
        <span className={styles.description}>
          Вы можете подать заявку на улучшение жилищных условий
        </span>
        <Link href={staticLinks.homeApplication} className={styles.link}>
          Подать заявку
        </Link>
      </div>
    ),
    offers: [
      {
        name: 'Льготная ипотека',
        descriptions: [
          {
            listType: 'decimal',
            lines: [
              'Зайти на сайт <a href="https://sakhipoteka.ru">sakhipoteka.ru</a>',
              'Заполнить форму, определив категорию ипотечной программы',
              'Открыть вкладку «Дальневосточная ипотека»',
              'Ознакомиться с условиями программы.',
              'Выбрать подходящий банк',
              'Подать заявку.',
            ],

            links: [
              {
                name: 'ipoteka.sakhalin.gov.ru',
                url: 'https://ipoteka.sakhalin.gov.ru/web/app/?name=requirements',
                qr: qrIpoteka.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Подача договора купли продажи квартиры в МФЦ',
        descriptions: [
          {
            hint: 'Записаться в МФЦ на подачу на регистрацию',

            links: [
              {
                name: 'gosuslugi65.ru/pgu/mfc/list',
                url: 'https://gosuslugi65.ru/pgu/mfc/list.htm',
                qr: qrDogovor.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Программа «Шаг за шагом»: улучшение жилищных условий.',
        descriptions: [
          {
            hint: 'Записаться в МФЦ на подачу на регистрацию',

            links: [
              {
                name: 'minstroy.sakhalin.gov.ru',
                url: 'https://minstroy.sakhalin.gov.ru/',
                qr: qrStep.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Налоговый вычет за приобретение жилья:',
        descriptions: [
          {
            listType: 'decimal',
            lines: [
              'Заполнить налоговую декларацию (по форме 3-НДФЛ). ',
              'Получить справку из бухгалтерии по месту работы о налогах за год по форме 2-НДФЛ.',
              'Подготовить копии документов о приобретении жилья, платежных документов, свидетельства о браке (при наличии) и письменное заявление. ',
              'Подать в налоговую по месту жительства. ',
            ],
            links: [
              {
                name: 'nalog.gov.ru',
                url: 'https://www.nalog.gov.ru/rn65/taxation/taxes/ndfl/nalog_vichet/im_nv/im_nv_pi/',
                qr: qrNalog.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Материнский семейный капитал на приобретение жилья:',
        descriptions: [
          {
            listType: 'decimal',
            lines: [
              'Подать в заявление на использование МСК в СФР.',
              'Сканируй QR-код и переходи по ссылке.',
            ],
            links: [
              {
                name: 'www.gosuslugi.ru/10061',
                url: 'https://www.gosuslugi.ru/10061',
                qr: qrKapital.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Программы по улучшению жилищных условий и иных мерах государственной поддержки',
        descriptions: [
          {
            hint: 'Получить информацию о реализуемых мерах государственной поддержки на приобретение/строительство жилья.',
            links: [
              {
                name: 'msz.sakhalin.gov.ru/node/15299',
                url: 'https://msz.sakhalin.gov.ru/node/15299',
                qr: qrProgrammy.src,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Как сделать общественное пространство лучше?',
    offers: [
      {
        name: 'Прими участие в благоустройстве подъезда, двора, района.',
        descriptions: [
          {
            links: [
              {
                name: 'minstroy.sakhalin.gov.ru',
                url: 'https://minstroy.sakhalin.gov.ru/',
                qr: qrUchastie1.src,
              },
              {
                name: 'gkh.admsakhalin.ru',
                url: 'https://gkh.admsakhalin.ru/',
                qr: qrUchastie2.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Спорт: для тебя и ребенка',
        descriptions: [
          {
            listType: 'decimal',
            lines: [
              'Сканировать QR-код и перейти по ссылке.',
              'Узнать про все спортивные секции, мероприятия, соревнования',
            ],
            links: [
              {
                name: 'sport.sakhalin.gov.ru',
                url: 'https://sport.sakhalin.gov.ru/',
                qr: qrSport.src,
              },
            ],
          },
        ],
      },
      {
        name: 'Культура:',
        descriptions: [
          {
            hint: 'Увидеть больше чудных мгновений, чтобы вспоминать о них вечерами, проще всего с программой «Пушкинская карта».',
            subtitle: 'Как принять участие в программе?',
            listType: 'decimal',
            lines: [
              'Зарегистрироваться на портале «Госуслуги».',
              'Подтвердить учетную запись',
              'Установить мобильное приложение «Госуслуги.Культура».',
              'Получить Пушкинскую карту — виртуальную или пластиковую карту платежной системы «Мир».',
              'Выбрать мероприятие из афиши в приложении.',
              'Купить билет в приложении, на сайте или в кассе.',
            ],
            links: [
              {
                name: 'culture.ru',
                url: 'https://culture.ru',
                qr: qrCulture.src,
              },
            ],
          },
        ],
      },
    ],
  },
] as THouseContent[];
